"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileSceneRightsholderTab = void 0;
const react_1 = __importStar(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const rightsholder_statuses_1 = require("@Const/rightsholder-statuses");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const ButtonRegistrationRightsHolder_1 = require("@Components/Buttons/ButtonRegistrationRightsHolder");
const topRightsHoldersSection_1 = require("@Components/topRightsHoldersSection");
const navigation_1 = __importDefault(require("@App/navigation"));
const rightsholder_1 = require("@App/api/routes/rightsholder/rightsholder");
const get_rigthsholder_pagination_status_1 = require("@App/helpers/get-rigthsholder-pagination-status");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const ProfileSceneRightsholderTab = () => {
    const limitItems = 6;
    const [pendingData, setPendingData] = (0, react_1.useState)();
    const [failedData, setFailedData] = (0, react_1.useState)();
    const [pendingPreloader, setPendingPreloader] = (0, react_1.useState)(true);
    const [failedPreloader, setFailedPreloader] = (0, react_1.useState)(true);
    const [isPopupOpen, setPopupOpen] = (0, react_1.useState)(false);
    const [rightsholderIdRedirect, setRightsholderIdRedirect] = (0, react_1.useState)();
    const setOpeningStatusPopup = (status, id) => {
        setPopupOpen(status);
        if (id) {
            setRightsholderIdRedirect(id);
        }
    };
    const getRightsHolders = (status, pending, callBackPagination) => __awaiter(void 0, void 0, void 0, function* () {
        const newStatus = (0, get_rigthsholder_pagination_status_1.generateRightsholderPaginationStatus)(status);
        const body = Object.assign(Object.assign(Object.assign({ limit: limitItems, page: 1 }, (newStatus && { status: newStatus })), { pending }), (callBackPagination && callBackPagination));
        // Bypass the store for these, they're not used elsewhere
        const rightsholderResponse = yield (0, rightsholder_1.getRightsholders)(body);
        const rightsholders = rightsholderResponse.data;
        let nextPagination;
        if (body && body.limit && body.page && rightsholders) {
            nextPagination = (0, calc_num_pages_1.calcNumPages)(rightsholders.count, body.limit, body.page);
        }
        return { data: rightsholders, pagination: nextPagination };
    });
    const getPendingRightsHolders = (callBackPagination) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield getRightsHolders(rightsholder_statuses_1.RIGHTSHOLDER_GROUP.pending, true, callBackPagination);
        setPendingData(result);
        setPendingPreloader(false);
    });
    const getFailedRightsHolders = (callBackPagination) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield getRightsHolders(rightsholder_statuses_1.RIGHTSHOLDER_GROUP.failed, undefined, callBackPagination);
        setFailedData(result);
        setFailedPreloader(false);
    });
    (0, react_1.useEffect)(() => {
        Promise.all([getPendingRightsHolders(), getFailedRightsHolders()]).then();
    }, []);
    const fullCount = pendingData && failedData && pendingData.data.count + failedData.data.count;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'profile-scene-rightsholder-tab' },
            react_1.default.createElement("div", { className: 'tab-head' },
                react_1.default.createElement("h5", null,
                    fullCount,
                    "\u00A0",
                    fullCount === 1 ? 'Member' : 'Members'),
                react_1.default.createElement(ButtonRegistrationRightsHolder_1.ButtonRegistrationRightsHolder, { mainColor: true })),
            react_1.default.createElement(topRightsHoldersSection_1.TopRightsHoldersSection, { name: 'Pending', rightsHolders: pendingData && pendingData.data, preloader: pendingPreloader, limitItems: limitItems, openPopup: setOpeningStatusPopup, paginationPages: pendingData && pendingData.pagination, onChangePagination: getPendingRightsHolders, viewDetails: false }),
            react_1.default.createElement(topRightsHoldersSection_1.TopRightsHoldersSection, { name: 'Failed', rightsHolders: failedData && failedData.data, preloader: failedPreloader, limitItems: limitItems, openPopup: setOpeningStatusPopup, paginationPages: failedData && failedData.pagination, onChangePagination: getFailedRightsHolders, viewDetails: false })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: isPopupOpen },
            react_1.default.createElement("div", { className: "redirect-verification-popup" },
                react_1.default.createElement("h3", null, "Please review your mailing and financial information."),
                react_1.default.createElement("div", { className: "links-block" },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: () => {
                            setOpeningStatusPopup(false);
                        } }, "CANCEL"),
                    rightsholderIdRedirect && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', typeLink: true, linkTo: navigation_1.default.rightholder.maintenance.root(rightsholderIdRedirect) }, "REVIEW INFO")))))));
};
exports.ProfileSceneRightsholderTab = ProfileSceneRightsholderTab;
